"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assePreviewApi = assePreviewApi;
exports.assePreviewDocApi = assePreviewDocApi;
exports.assetAddAccessPermissionApi = assetAddAccessPermissionApi;
exports.assetCoverImageListApi = assetCoverImageListApi;
exports.assetCreateApi = assetCreateApi;
exports.assetDeleteApi = assetDeleteApi;
exports.assetDownloadApi = assetDownloadApi;
exports.assetDownloadUrlApi = assetDownloadUrlApi;
exports.assetGetAccessPermissionApi = assetGetAccessPermissionApi;
exports.assetListApi = assetListApi;
exports.assetReportCoverImageListApi = assetReportCoverImageListApi;
exports.assetUpdateAccessPermissionApi = assetUpdateAccessPermissionApi;
exports.assetUpdateApi = assetUpdateApi;
exports.assetsGetPresignedApi = assetsGetPresignedApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * create
 * @param payload
 * @returns api response
 * @description this function used to create asset.
 */
function assetCreateApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.AssetsService.asset.root), params);
}

/**
 * download
 * @param payload
 * @returns api response
 * @description this function used to download asset.
 */
function assetDownloadApi(params) {
  return api.getFile("".concat(_app.default.baseUrl + _dashboard.AssetsService.asset.download), params);
}

/**
 * download
 * @param payload
 * @returns api response
 * @description this function used to download asset.
 */
function assetDownloadUrlApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.AssetsService.asset.downloadUrl), params);
}

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function assetsGetPresignedApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.AssetsService.asset.preSignedUrl), params);
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update asset.
 */
function assetUpdateApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.AssetsService.asset.update), params);
}

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get asset.
 */
function assetListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.AssetsService.asset.list), params);
}

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to delete asset.
 */
function assetDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.AssetsService.asset.delete), params);
}

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to preview.
 */
function assePreviewApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.AssetsService.asset.preview), params);
}

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to preview.
 */
function assePreviewDocApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.AssetsService.asset.previewDoc), params);
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update permission.
 */
function assetUpdateAccessPermissionApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.AssetsService.asset.updateAccessPermission), params);
}

/**
 * create
 * @param payload
 * @returns api response
 * @description this function used to create permission.
 */
function assetAddAccessPermissionApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.AssetsService.asset.addAccessPermission), params);
}

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get images.
 */
function assetCoverImageListApi(params) {
  return generateResponse(params);
}

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get images.
 */
function assetReportCoverImageListApi(params) {
  return generateResponse(params);
}
var generateResponse = function generateResponse(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.AssetsService.asset.coverImageList), params);
};

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get permission.
 */
function assetGetAccessPermissionApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.AssetsService.asset.getAccessPermission), params);
}